import { FunctionComponent, useState } from "react"
import { CartStructure } from "../../interfaces/SaleorTypes"
import { Container } from "react-grid-system"
import { HorizontalSpacer } from "../../atoms/spacers"
import LargeButton from "../../atoms/buttons/LargeButton"
import { Row } from "react-grid-system"
import styled from "styled-components"
import { useCreateUnpaidOrderMutation } from "../../../hooks/useCreateUnpaidOrder"
import { CheckoutType } from "../../../graphql/mutations/createUnpaidOrder"
import { useCheckoutEmailUpdateMutation } from "../../../hooks-saleor/checkoutEmailUpdateMutation"
import { useNavigate } from "react-router-dom"
import Body from "../../atoms/typography/Body"
import { theme } from "../../theme"
import SmallColorfulButton from "../../atoms/buttons/SmallColorfulButton"

interface UnpaidOrderProps {
  cart: CartStructure[]
  checkoutType: CheckoutType
  formData: HTMLFormControlsCollection
  checkoutId: string
  onClearCart: () => void
}

const PaymentButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 32px 60px;
  gap: 9px;
  background: #616161;
  border: 1px solid #616161;
  box-shadow: 0px 1px 3px 1px rgba(119, 119, 119, 0.25);
  border-radius: 5px;
  margin: auto;
`

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const CheckoutUnpaidOrder: FunctionComponent<UnpaidOrderProps> = ({
  cart,
  formData,
  onClearCart,
  checkoutType,
  checkoutId,
  ...props
}) => {
  const { checkoutEmailUpdateMutation } = useCheckoutEmailUpdateMutation()
  const { createUnpaidOrderMutation } = useCreateUnpaidOrderMutation()
  const [previousEmail, setPreviousEmail] = useState<string>(formData["billing-email"]?.value)
  const [previousPassword, setPreaviousPassword] = useState<string>(formData["account-password"]?.value)
  const [errors, setErrors] = useState("")

  const navigate = useNavigate()

  const onCreateUnpaidOrder = async () => {
    if (formData && checkoutId) {
      if (
        previousEmail != formData["billing-email"]?.value ||
        previousPassword != formData["account-password"]?.value
      ) {
        await checkoutEmailUpdateMutation({
          variables: {
            checkoutId: checkoutId,
            email: formData["billing-email"]?.value,
          },
        })
      }
      setPreviousEmail(formData["billing-email"]?.value)
      setPreaviousPassword(formData["account-password"]?.value)
      createUnpaidOrderMutation({
        variables: {
          checkoutId: checkoutId,
          email: formData["billing-email"]?.value,
          checkoutType: checkoutType,
        },
      })
        .then((response) => {
          onClearCart()
          navigate(`/store/confirmation?checkout_id=${checkoutId}`)
        })
        .catch((response) => {
          setErrors("You already have a pending order with us.")
        })
    }
  }

  const renderErrors = () => {
    if (errors) {
      return (
        <ErrorContainer>
          <Body color={theme.colors.red} textAlign="center">
            {errors}
          </Body>
        </ErrorContainer>
      )
    }
  }

  return (
    <Container>
      <HorizontalSpacer spacing={2} />
      <Row justify="center">
        <SmallColorfulButton
          onClick={() => onCreateUnpaidOrder()}
          title={checkoutType === "leasing" ? "Create leasing offer" : "Create rental request"}
        />
      </Row>
      {renderErrors()}
    </Container>
  )
}

export default CheckoutUnpaidOrder
